import { Link } from 'react-router-dom'
import Icon from '../Icon'
import Logo from '../Logo'
import { company, footerNav } from '../../data/site'

/**
 * Site footer.
 *
 * The old site rendered an empty <footer>, which left the Impressum and the
 * Datenschutzerklärung reachable only by guessing their URLs. For a German site
 * the Impressum has to be reachable from every page (§ 5 TMG), so both live
 * here, along with the § 34c GewO licence and the register details.
 */
export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <Logo variant="full" eager={false} />
            <p>
              CASA Hausverwaltung ist ein Unternehmen der {company.legalName}.
              Wir verwalten WEG, Sondereigentum und Mehrfamilienhäuser in der
              Region - mit Erfahrung aus eigenem Bestand.
            </p>
            <p style={{ marginTop: 'var(--s-4)' }}>
              <span className="badge badge--dark">{company.licence}</span>
            </p>
          </div>

          <div>
            <h2 className="footer__col-title">Verwalten</h2>
            <ul className="footer__list">
              {footerNav.leistungen.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="footer__col-title">Unternehmen</h2>
            <ul className="footer__list">
              {footerNav.unternehmen.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="footer__col-title">Kontakt</h2>
            <address className="footer__address">
              <div>
                <strong>{company.legalName}</strong>
                <br />
                {company.street}
                <br />
                {company.postalCode} {company.city}
              </div>
              <a href={company.phoneHref}>
                <Icon
                  name="phone"
                  className="footer__icon"
                  aria-hidden="true"
                />
                {company.phone}
              </a>
              <a href={company.emailHref}>
                <Icon name="mail" className="footer__icon" aria-hidden="true" />
                {company.email}
              </a>
            </address>
          </div>
        </div>

        <div className="footer__legal">
          <p className="footer__note">
            © {year} {company.legalName} · USt-IdNr. {company.vatId} ·{' '}
            {company.registration}, {company.registerCourt}
          </p>
          <nav aria-label="Rechtliches">
            <div className="footer__legal-links">
              {footerNav.legal.map((item) => (
                <Link key={item.to} to={item.to}>
                  {item.label}
                </Link>
              ))}
            </div>
          </nav>
        </div>
      </div>
    </footer>
  )
}
